// useFetch3.ts
// добавление зависимостей
import { useState, useEffect, useCallback, useRef } from "react"; 
import { ref } from "yup";

export function useFetch<T>(
  apiCall: (payload?: any) => Promise<T>,
  defaultValue: T,
  initialPayload: any = {},
  dependencies: any[] = [],
) {
  const defaultValueRef = useRef(defaultValue);
  const [data, setData] = useState<T>(defaultValueRef.current);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  
  // Використовуємо ref для актуального payload, щоб уникнути зайвих циклів рендеру
  const [payload, setPayload] = useState(initialPayload);

  const fetchData = useCallback(
    async (pl: any = payload) => {
      setLoading(true);
      setError(null);
      try {
        const result = await apiCall(pl);
        setData(result);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    },
    [apiCall] // Видаляємо payload звідси, щоб уникнути зациклення
  );

  // Слідкуємо за зміною залежностей (наприклад, customer_id)
  useEffect(() => {
    // Оновлюємо внутрішній payload, якщо прийшли нові пропси
    setPayload(initialPayload);
    fetchData(initialPayload);
  }, dependencies); // Ось тут відбувається "магія" оновлення

  const update = useCallback(
    async (newPayload: any = {}) => {
      setPayload(newPayload);
      await fetchData(newPayload);
    },
    [fetchData]
  );

  return { data, loading, error, setData, update, refresh: () => fetchData(payload) };
}